import React from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import SingleUser from "./SingleUser";

const MobileOffcanvas = ({
  show,
  handleClose,
  data,
  singleChatView,
  aciveUserMessage,
}) => {
  return (
    <>
      <Offcanvas show={show} onHide={handleClose} backdrop="static">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>User</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="row clearfix mobile-chats-section">
            <div className="col-lg-12">
              <div className="chat-card chat-app">
                <div id="plist" className="mobile-pepole-list">
                  <ul className="list-unstyled chat-list mt-2 mb-0">
                    {data.length !== 0 ? (
                      data.map((data, index) => {
                        if (data) {
                          return (
                            <SingleUser
                              data={data}
                              index={index}
                              key={data._id}
                              singleChatView={singleChatView}
                              aciveUserMessage={aciveUserMessage}
                              handleClose={handleClose}
                            ></SingleUser>
                          );
                        }
                      })
                    ) : (
                      <div>
                        <div className="text-dark text-center" colspan="100%">
                          Data not availabe
                        </div>
                      </div>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default MobileOffcanvas;
